import { ControllersDataItem, LogicContext } from '../types';
import config from '../../../config';
import { getGroupedCodesFromJPTiles } from '../../../utils/jackpotsV2/getGroupedCodesFromJPTiles';
import { getJackpotsForJPTiles } from '../../../utils/jackpotsV2/getJackpotsForJPTiles';

export const fetchJackpots = async (context: LogicContext) => {
  const { controllersData } = context;

  if (!controllersData.categories) {
    return {
      multiJackpots: {},
    };
  }

  const { components } = controllersData.categories;
  const currency = context.user?.currency || config.default_currency;

  return {
    multiJackpots: await getMultiJackpots(components, currency),
  };
};

const getMultiJackpots = (
  components: ControllersDataItem['components'],
  currency?: string
) => {
  const groupedJPCodesEntries = getGroupedCodesFromJPTiles(components);
  return groupedJPCodesEntries.length
    ? getJackpotsForJPTiles(groupedJPCodesEntries, currency)
    : Promise.resolve({});
};
